import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-511840ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute_cell tw-flex tw-justify-center tw-w-full" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "tw-flex" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "score-title" }
const _hoisted_6 = {
  key: 0,
  class: "tw-text-[#FFF] tw-h-[28px] loading-icon"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-2 tw-h-full tw-cursor-default" }, null, -1))
const _hoisted_8 = { class: "absolute_cell tw-flex tw-justify-center tw-w-full" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-2 tw-h-full tw-cursor-default" }, null, -1))
const _hoisted_11 = { class: "absolute_cell tw-flex tw-justify-center tw-w-full" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-2 tw-h-full tw-cursor-default" }, null, -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "tw-absolute tw-top-0 tw-right-0 tw-bottom-0 tw-left-0 tw-flex tw-flex-row tw-items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-2 tw-h-full" }, null, -1))
const _hoisted_17 = { class: "tw-relative tw-flex-1 tw-h-full tw-w-[45px] tw-flex tw-items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-2 tw-h-full" }, null, -1))

import { onMounted, ref, watch } from "vue";
import { CustomTableColumn } from "../common/customTable.vue";
import { getComponentUiText, getTagRelativeRisk } from "@/utils/utilities";
import CustomTableCanDropDrag from "@/components/common/customTableCanDropDrag.vue";
import CellTableAction from "@/components/common/setting/cellTableAction.vue";
import ScoreIncrease from "@/components/assessments/scoreIncreaseElement.vue";
import StatusBadge from "@/components/common/setting/statusBadge.vue";
import ArrowDownTableIcon from "../svgs/arrowDownTableIcon.vue";
import {
  actionClickType,
  MODAL_NAME,
  statusCode,
  DRAG_AND_DROP_TABLE_TYPE,
} from "@/utils/constants";
import DetailRowActionTable from "../recommend/detailRowActionTable.vue";
import { dataActionTableColumn } from "@/interfaces/recommendations/IActionInterfaces";
import { IModalMessage } from "@/interfaces/common/common";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { Ref } from "vue";
import { computed } from "vue";
import store from "@/store";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'suggestedActionsTable',
  props: {
  dataRow: {
    type: Array as () => dataActionTableColumn[],
    required: true,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    required: false,
  },
  headerClass: {
    type: String,
    required: false,
    default: "",
  },
  titleButton: {
    type: String,
    required: false,
    default: null,
  },
  rowClass: {
    type: String,
    required: false,
    default: "",
  },
  titleActionValue: {
    type: String,
    required: false,
    default: null,
  },
  isShowCheckbox: {
    type: Boolean,
    required: false,
    default: true,
  },
  isShowMeatball: {
    type: Boolean,
    required: false,
    default: true,
  },
  isChecklistStatusDone: {
    type: Boolean,
    required: false,
  },
  isCalling: {
    type: Boolean,
    required: false,
  },
  activeId: {
    type: String,
    required: false,
    default: null,
  },
  isShowLoading: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["update-selected-rows", "update-add-action"],
  setup(__props, { emit }) {

const props = __props;



const dataformat = computed(() => {
  return dataTable.value.map((item) => {
    return {
      ...item,
      rowBgColor: item?.isSuggested ? null : "#FCFCFD",
    };
  });
});
const dataTable = ref(props.dataRow);
let currentSeletedRow: any[] = [];
const tableFileActions = [actionClickType.actionEditActionRecomendation];
const dataPercentile: Ref<any> = computed(() => {
  return store.state.Recommend.percentileChecklistGroupTemplateMetrics;
});


const addAction = (id, event) => {
  event.stopPropagation();
  emit("update-add-action", {
    isSuggestionsAction: true,
    addedActions: [id],
  });
};

const removeData = (item) => {
  const id = item.elementId;
  if (currentSeletedRow.includes(id)) {
    dataTable.value = dataTable.value.filter(
      (item) => !currentSeletedRow.includes(item.id),
    );
  } else dataTable.value = dataTable.value.filter((item) => item.id !== id);
};

onMounted(() => {
  formatData();
});

const updateSelectedRows = (seletedRow) => {
  currentSeletedRow = seletedRow;
  emit("update-selected-rows", seletedRow);
};

const idItemExpland = ref(null);

const handleActionClick = (value: any, action: string) => {
  switch (action) {
    case actionClickType.actionEditActionRecomendation:
      onShowEditActionModal(value);
      break;
    default:
      break;
  }
};

const onShowEditActionModal = (action: any) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMENDATION_EDIT_ACTIONS,
    properties: {
      action,
      isEditActionTable: false,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const columnsTableFields: CustomTableColumn[] = [
  {
    text:
      props.titleActionValue ??
      getComponentUiText("app-user-profile-form-label-title-1"),
    value: "title",
    headerClass: `tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase ${props.headerClass}`,
    sortable: false,
    headerWrapperId: "",
    valueClass: "!tw-relative tw-min-h-[60px] tw-cursor-pointer",
    isActiveClick: false,
  },
  {
    text: getComponentUiText(
      "app-assess-recommendations-action-table-header-score-increase-1",
    ),
    value: "scoreIncreaseTotal",
    // style center tw-w-[260px] tw-flex tw-justify-center
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase tw-pr-[40px]",
    valueClass: "!tw-w-[280px] !tw-relative tw-cursor-pointer",
    headerWrapperId: "recom-suggested-action-table-score-increase",
    sortable: true,
    sortDefault: true,
    isActiveClick: false,
  },
  {
    text: getComponentUiText(
      "app-assess-recommendations-action-table-header-relative-risk-1",
    ),
    value: "relativeRiskValue",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase !tw-pr-0",
    valueClass: "!tw-w-[111px] !tw-relative",
    headerWrapperId: "recom-action-table-relative-risk",
    sortable: true,
    sortDefault: false,
  },
  {
    text: "",
    value: "action",
    headerClass: "",
    valueClass: "!tw-w-[61px] !tw-px-0 !tw-py-0 !tw-relative",
  },
  {
    text: "",
    value: "expland",
    headerClass: "",
    valueClass: "!tw-w-[12px] !tw-relative tw-cursor-pointer",
    isActiveClick: true,
  },
];

const formatData = () => {
  dataTable.value.map((obj) => ({ ...obj, isSuggestionsAction: true }));
};

watch(
  () => props.dataRow,
  () => {
    dataTable.value = props.dataRow;
    formatData();
  },
);

const onClickOpenRow = (item, col, e) => {
  if (!col.isActiveClick) return;
  if (item.id === idItemExpland.value) {
    idItemExpland.value = null;
  } else {
    idItemExpland.value = item.id;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(CustomTableCanDropDrag, {
    draggable: !__props.isChecklistStatusDone,
    columns: columnsTableFields,
    data: dataformat.value,
    "is-loading": __props.isLoading,
    "id-item-expland": idItemExpland.value,
    "show-checkbox-row": __props.isShowCheckbox,
    reorderable: false,
    "table-type": _unref(DRAG_AND_DROP_TABLE_TYPE).SUGGESTEDACTIONS,
    "is-recommend": true,
    "header-wrapper-class": "!tw-bg-[#FCFCFD]",
    onUpdateSelectedRows: _cache[0] || (_cache[0] = ($event: any) => (updateSelectedRows($event))),
    onRemoved: removeData,
    onClickedRow: onClickOpenRow
  }, {
    "cell(title)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "tw-flex tw-items-center tw-flex-1 tw-h-full tw-cursor-pointer",
          onClick: (e) => onClickOpenRow(data.item, columnsTableFields[4], e)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(`tw-flex-1 tw-flex tw-gap-[17px] tw-items-center ${__props.rowClass}`)
          }, [
            _createVNode(StatusBadge, {
              value: 
                data?.item?.isSuggested
                  ? _unref(statusCode).suggested
                  : _unref(statusCode).applied
              ,
              class: "tw-w-fit"
            }, null, 8, ["value"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(data.value) + " ", 1),
                _createElementVNode("span", _hoisted_5, "(" + _toDisplayString(data.item.checklistGroupItemCount) + ")", 1)
              ])
            ]),
            _createVNode(_component_b_button, {
              disabled: __props.isChecklistStatusDone,
              style: _normalizeStyle(
                __props.activeId === data.item?.id && __props.isCalling && __props.isShowLoading
                  ? `background-color: #0b5ed7`
                  : ``
              ),
              "data-cy": "suggested-action-table-add-button",
              variant: "primary",
              class: _normalizeClass({
                'suggest-add-btn tw-h-[28px] tw-relative tw-flex tw-justify-center tw-items-center tw-w-fit tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-px-[16px] tw-text-[11px] tw-font-medium tw-rounded-[50px]': true,
                '!tw-cursor-not-allowed !tw-bg-[#b7b7b7] !tw-border-0':
                  __props.isChecklistStatusDone,
              }),
              onClick: ($event: any) => (addAction(data.item, $event))
            }, {
              default: _withCtx(() => [
                (__props.activeId === data.item?.id && __props.isCalling && __props.isShowLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_unref(LottieAnimation), {
                        ref: "anim",
                        "animation-data": _unref(ProgressAnimation),
                        "auto-play": true,
                        loop: true,
                        style: { height: '28px' }
                      }, null, 8, ["animation-data"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  style: _normalizeStyle(
                  __props.activeId === data.item?.id && __props.isCalling && __props.isShowLoading
                    ? `visibility: hidden`
                    : ``
                )
                }, _toDisplayString(_unref(getComponentUiText)(
                    "app-assess-recommendations-action-table-button-title-add-1",
                  )), 5)
              ]),
              _: 2
            }, 1032, ["disabled", "style", "class", "onClick"])
          ], 2)
        ], 8, _hoisted_2),
        _hoisted_7
      ])
    ]),
    "cell(scoreIncreaseTotal)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "tw-flex tw-items-center tw-flex-1 tw-h-full tw-cursor-pointer",
          onClick: (e) => onClickOpenRow(data.item, columnsTableFields[4], e)
        }, [
          _createVNode(ScoreIncrease, {
            "first-score": data.item.scoreIncreaseFirstCount,
            "total-score": data.item.scoreIncreaseTotal
          }, null, 8, ["first-score", "total-score"])
        ], 8, _hoisted_9),
        _hoisted_10
      ])
    ]),
    "cell(relativeRiskValue)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: "tw-flex tw-items-center tw-justify-center tw-flex-1 tw-h-full tw-cursor-pointer",
          onClick: (e) => onClickOpenRow(data.item, columnsTableFields[4], e)
        }, [
          (_unref(getTagRelativeRisk)(data.value, dataPercentile.value))
            ? (_openBlock(), _createBlock(StatusBadge, {
                key: 0,
                value: _unref(getTagRelativeRisk)(data.value, dataPercentile.value) ?? '',
                class: "tw-w-fit"
              }, null, 8, ["value"]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_12),
        _hoisted_13,
        _createElementVNode("div", {
          class: "tw-w-[25px] tw-h-full tw-cursor-pointer",
          onClick: (e) => onClickOpenRow(data.item, columnsTableFields[4], e)
        }, null, 8, _hoisted_14)
      ])
    ]),
    "cell(action)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          (__props.isShowMeatball)
            ? (_openBlock(), _createBlock(CellTableAction, {
                key: 0,
                id: 
              'recommended-suggested-action-table-' +
              (data.tablePrefix || '') +
              data.item.id
            ,
                class: "tw-overflow-hidden tw-h-full",
                disabled: __props.isChecklistStatusDone,
                value: data,
                "is-internal": false,
                actions: tableFileActions,
                "class-button": 'tw-w-[45px]',
                onManageUser: handleActionClick
              }, null, 8, ["id", "disabled", "value"]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_18
      ])
    ]),
    "cell(expland)": _withCtx((data) => [
      _createVNode(ArrowDownTableIcon, {
        class: _normalizeClass([
          data.item.id === idItemExpland.value ? 'show' : '',
          'tw-cursor-pointer',
        ])
      }, null, 8, ["class"])
    ]),
    detail: _withCtx((data) => [
      _createVNode(DetailRowActionTable, {
        "id-item-expand": idItemExpland.value,
        "detail-data": data
      }, null, 8, ["id-item-expand", "detail-data"])
    ]),
    _: 1
  }, 8, ["draggable", "data", "is-loading", "id-item-expland", "show-checkbox-row", "table-type"]))
}
}

})